import React, { Component } from 'react';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import { fetchFilterOptions, getFilteredResults } from '../actions';
import types from '../constants/actionTypes';
import debounce from 'lodash/debounce';
import CollectiveTypeToggle from '../components/CollectiveTypeToggle';

// Material UI Library
import Drawer from 'material-ui/Drawer';
import MenuItem from 'material-ui/MenuItem';
import AppBar from 'material-ui/AppBar';
import IconButton from 'material-ui/IconButton';
import FlatButton from 'material-ui/FlatButton';
import { List, ListItem } from 'material-ui/List';
import Divider from 'material-ui/Divider';
import Checkbox from 'material-ui/Checkbox';
import TextField from 'material-ui/TextField';
import Badge from 'material-ui/Badge';

import NavigationClose from 'material-ui/svg-icons/navigation/close';
import CommunicationClearAll from 'material-ui/svg-icons/communication/clear-all';
import { RefinementList, Index, PoweredBy  } from 'react-instantsearch/dom'
import { connectRefinementList, connectCurrentRefinements } from 'react-instantsearch/connectors';

class FilterDrawer extends Component {

  constructor(props) {
    super(props);
    this.debounceFetchResults = debounce(this.dispatchFilteredResults, 700);
  }

  componentDidMount() {
    this.props.dispatch(fetchFilterOptions());
  }

  handleSetActiveFilters = (ref, filterOption, e) => {
    this.props.dispatch({
      type: types.activeFilters.SET_ACTIVE_FILTER,
      id: ref.id,
      filterOption: filterOption,
    });
    this.debounceFetchResults();
  };

  dispatchFilteredResults = () => {
    this.props.dispatch(getFilteredResults());
  };

  handleClearFilters = () => {
    
  };

  handleSearchCity = (e, value) => {

    this.props.dispatch({
      type: types.activeFilters.SET_SEARCH_CITY,
      value: value,
    });

    if (value.length < 3 && value.length > 0) return;
    this.debounceFetchResults();
  }

  handleSearchState = (e, value) => {

    this.props.dispatch({
      type: types.activeFilters.SET_SEARCH_STATE,
      value: value,
    });

    // Continue if 0 length to clear the search results
    if (value.length < 2 && value.length > 0) return;

    this.debounceFetchResults();
  }

  render() {
    const drawerStyle = () => {
      if(window.innerWidth > this.props.breakpoint) {
        return {
          position: 'relative',
          width: (this.props.open ? 400 : 0),
          transition: 'width 200ms',
          minHeight: '100%',
        }
      }

      return {
        top: 'auto',
      }
    }

    return (
      <Drawer
        open={this.props.open}
        containerStyle={drawerStyle()}
        openSecondary={true}
        width={this.props.open ? 400 : 0}
      >
        <AppBar
          title="Filter"
          showMenuIconButton={false}
          iconElementRight={
            <IconButton onTouchTap={this.props.closeDrawer}>
              <NavigationClose />
            </IconButton>
          }
        >
        </AppBar>
        <div style={{ textAlign: 'right', margin: '5px' }}>
          <ConnectedMediaToggle attribute="type" defaultRefinement={['NewMediaCollective']} />
          <ClearFilters />
        </div>
        <List>
          <ConnectedListItem title="Media Platforms" attribute="media_platforms" />
          <Divider />
          <ConnectedListItem title="Game Genres" attribute="game_genres" />
          <Divider />
          <ConnectedListItem title="Game Platforms" attribute="game_platforms" />
          <Divider />
          <ConnectedListItem title="Interests" attribute="interests" />
          <Divider />
        </List>
        <PoweredBy />
      </Drawer>
    );
  }
}

const handleCheck = (label, refine, currentRefinement) => () => { 
  if (currentRefinement.indexOf(label) !== -1) {
    refine(currentRefinement.filter(i => i !== label))
  } else {
    refine([...currentRefinement, label])
  }
}

const handleClearFilters = (refine, items) => () => {
  console.log('handleclear', items)
  refine(items.filter((x) => x.currentRefinement.indexOf('type') !== -1));
}

const ClearFilters = connectCurrentRefinements(({ refine, items }) =>
  <FlatButton
    label="Clear Filters"
    icon={<CommunicationClearAll />}
    onTouchTap={handleClearFilters(refine, items)}
  />
)


const FacetedItem = ({ title, refine, currentRefinement, items }) => {
  
  return (
    <ListItem
      primaryText={title}
      initiallyOpen={false}
      primaryTogglesNestedList={true}
      nestedItems={items.sort((a, b) => a.label.localeCompare(b.label)).map(({ label, count }) =>
        <ListItem
          nestedLevel={2}
          key={`faceted-item-${label}`}
          rightIcon={
            <Badge badgeContent={count} badgeStyle={{ color: 'white', backgroundColor: '#555', fontSize: '0.65em' }} />
          }
        >
          <Checkbox
            checked={!!~currentRefinement.indexOf(label)}
            label={label}
            labelPosition="left"
            onCheck={handleCheck(label, refine, currentRefinement)}
          />
        </ListItem>
      )}
    />
  )
}

const ConnectedListItem = connectRefinementList(FacetedItem);

const ConnectedMediaToggle = connectRefinementList(CollectiveTypeToggle);

function mapToArray(store) {
  if (!store.get('result').size) return Immutable.List();

  return store.get('result').map(id =>
    store.get('entities').get(`${id}`)
  );
}

function mapStateToProps(state) {
  return {
    gameGenres: mapToArray(state.get('filterOptions').get('gameGenres')),
    gamePlatforms: mapToArray(state.get('filterOptions').get('gamePlatforms')),
    mediaPlatforms: mapToArray(state.get('filterOptions').get('mediaPlatforms')),
    channelStyles: mapToArray(state.get('filterOptions').get('channelStyles')),
    activeFilters: state.get('activeFilters'),
  };
}

export default connect(mapStateToProps)(FilterDrawer);



/** WEBPACK FOOTER **
 ** ./containers/FilterDrawer.js
 **/